import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { AuthService } from 'app/auth/auth.service';
import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_profile } from 'app/idiomas/i18n/profile/profile.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'app-perfil-usuario',
  templateUrl: './perfil-usuario.component.html',
  styleUrls: ['./perfil-usuario.component.scss'],
  animations   : fuseAnimations
})
export class PerfilUsuarioComponent implements OnInit {

  enviaDatosUsu: Subject<any> = new Subject<any>();
  menuAbierto = true;
  enlaceMenu: string;
  datosUsuario: any;

  enlaces = [
    { nombre: 'configuracion', icono: 'settings' },
    // { nombre: 'notificaciones', icono: 'notifications_active' },
    // { nombre: 'mensajes', icono: 'email' },
  ];

  constructor(
    private location: Location,
    private authService: AuthService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_profile.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.datosUsuario = this.authService.getInfoUsuario();
    //si solo hay un enlace "le da click" para que se muestre de inmediato
    if(this.enlaces.length == 1){
      this.enlaceMenu = this.enlaces[0].nombre;
      this.enviaInfoUsuario();
    }
  }

  enviaInfoUsuario(){
    setTimeout(() => {
      this.enviaDatosUsu.next(this.datosUsuario);
    }, 1000);
  }

  regresar(){
    this.location.back();
  }

}
